module.exports = __webpack_public_path__ + "img/app_dev.25f367e9.svg";